export default "__VITE_ASSET__XvNObjkM__"